import React from "react";
import { useReactiveVar } from "@apollo/client";
import { result } from "./../../stores"; // Ajuste o caminho com base na sua configuração
import { __ } from "@wordpress/i18n";

import Loading from "@components/Loading/Loading"; // Ajuste o caminho conforme necessário

// Definição dos tipos para as propriedades do componente ErrorMsg
interface ErrorMsgProps {
    statusCode?: number;
}

// Mensagens de erro
const ERROR_MESSAGES = {
    title: __("Oops...", "df-simulators"),
    description:
        __("Ocorreu um erro inesperado do nosso lado. Iremos resolver assim que possível.", "df-simulators"),
    unknownCode: __("Código desconhecido", "df-simulators"),
    loadingMessage: __("A carregar...", "df-simulators"),
};

/**
 * Componente para exibir uma mensagem de erro com o código de status.
 *
 * @param {ErrorMsgProps} props - As propriedades do componente.
 * @returns {JSX.Element} - Renderiza a mensagem de erro.
 */
const ErrorMsg: React.FC<ErrorMsgProps> = ({ statusCode }: ErrorMsgProps): JSX.Element => (
    <div className="tool-error" role="alert" aria-live="assertive">
        <h2>{ERROR_MESSAGES.title}</h2>
        <p className="tool-error__message">{ERROR_MESSAGES.description}</p>
        <p className="tool-error__code">
          {__("Erro:", "df-simulators")} {statusCode || ERROR_MESSAGES.unknownCode}
        </p>
    </div>
);

/**
 * Componente principal para gerenciar estados de erro e carregamento.
 *
 * @returns {JSX.Element} - Renderiza o estado de carregamento ou a mensagem de erro.
 */
const Error: React.FC = (): JSX.Element => {
    const { response, loading, statusCode } = useReactiveVar(result);

    if (loading && !response) {
        return <Loading message={ERROR_MESSAGES.loadingMessage} />;
    }

    return <ErrorMsg statusCode={statusCode} />;
};

export default Error;
